import { PkBatch } from 'src/features/stock-movements/StockMovementsTypes'
import * as S from './PkBatchTable.styles'
import { formatDateReplaceHour } from 'src/utils/formatDate'

interface Props {
  batches: PkBatch[]
  color: string
}

export const PkBatchTable = ({ batches, color }: Props) => (
  <S.Table color={color}>
    <S.THead>
      <S.Tr>
        <S.Th color={color}>Nº Etiqueta</S.Th>
        <S.Th color={color}>Validade</S.Th>
        <S.Th color={color} style={{ paddingRight: '20px' }}>Qtd.</S.Th>
      </S.Tr>
    </S.THead>
    <S.TBody>
      {batches.map((batch) => (
        <S.Tr key={batch.idBatchReceivement}>
          <S.Td color={color}>
            {batch.batchNumber}
          </S.Td>
          <S.Td color={color}>
            {formatDateReplaceHour(new Date(batch.expirationDate))}
          </S.Td>
          <S.Td color={color}>
            {batch.quantity}
          </S.Td>
        </S.Tr>
      ))}
    </S.TBody>
  </S.Table>
)
